import { render, staticRenderFns } from "./AmenityList.vue?vue&type=template&id=34e8a0c3"
import script from "./AmenityList.vue?vue&type=script&lang=js"
export * from "./AmenityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports